import React from 'react';
import {
  FDDialogActions,
  FDDialogTitle,
  FDDialogContent,
  FDTextButton,
  FDBodyText,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  OnboardingCapacityOverride,
} from 'Components/AdvisorApp/Viewport/Users/OnboardingCapacityDialog/OnboardingCapacityOverride';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import NewOnboardingCapacityItem
  from 'Components/AdvisorApp/Viewport/Users/OnboardingCapacityDialog/NewOnboardingCapacityItem';
import AgentOnboardingCapacityTable
  from 'Components/AdvisorApp/Viewport/Users/OnboardingCapacityDialog/AgentOnboardingCapacityTable';

const OnboardingCapacityDialogContent = ({
  onClose, submitNewOnboardingCapacityItem, newOnboardingCapacityItemResource, deleteOnboardingCapacityItem, submitting,
}) => {
  const { resource } = useMetaLayoutContext();
  return (
    <>
      <FDDialogTitle value={resource.attr('title')} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={1}>
          <FDBodyText value={resource.attr('agentName')} size={'lg'} />
          <MetaResourceRenderer
            resource={newOnboardingCapacityItemResource}
            layout={NewOnboardingCapacityItem}
            metaOverrideSet={OnboardingCapacityOverride}
            LayoutProps={{
              submitNewOnboardingCapacityItem,
              submitting,
            }}
          />
          <AgentOnboardingCapacityTable deleteOnboardingCapacityItem={deleteOnboardingCapacityItem} submitting={submitting} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDTextButton
          label={'Close'}
          onClick={() => onClose()}
          disabled={submitting}
        />
      </FDDialogActions>
    </>
  );
};


export default OnboardingCapacityDialogContent;
